import { render } from "./OnDemandAssessmentCompletedPurchasesPage.vue?vue&type=template&id=5077dd55"
import script from "./OnDemandAssessmentCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./OnDemandAssessmentCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__